/* Save-this-ring box (F01, 2026-11-02; D20, D21). Markup: snippets/beylora-save-ring.liquid.
   A shopper types an email; this script posts {email, variant_id, website} to the custom ring service's save route.
   The service reads the ring from Shopify and does the list signup and the "Saved Ring" event with its own key,
   so nothing here talks to the email provider and the page carries no provider id.
   The box renders hidden: this script shows it, and only after the save route's own switch answers {ok:true,on:true} (D28 b).
   Off, an error, a timeout or any other answer keeps the box hidden and sends nothing. Without the script the form stays hidden.
   One delegated listener on the document, so it survives the product section re-rendering when a carat or metal is picked.
   The chosen variant is read at submit time, after any carat or metal change in flight has settled.
   A late answer never moves what the shopper is looking at (D42 f): once they have scrolled or touched the page, the box
   is unhidden only if it sits wholly below the screen and the shopper has not yet reached the variant picker above Add to cart
   (D69 puts the box under Add to cart); otherwise it stays hidden for this load and the kept on shows it next load.
   A send that answers 429 drops the kept on, so the next load asks the status route again (D42 e). */
(function () {
  'use strict';
  if (window.__beySaveRing) return;
  window.__beySaveRing = true;

  var ROUTE = 'https://custom-rings-production.up.railway.app/v1/ring-saves';
  var STATUS_ROUTE = ROUTE + '/status';
  var STATUS_TIMEOUT_MS = 4000;
  var ON_KEEP_MS = 10 * 60 * 1000;
  var ON_KEY = 'beySaveRingOn';
  var MSG_BAD = 'Enter a full email address.';
  var MSG_SENT = 'Sent. Check your inbox.';
  var MSG_FAIL = 'Not sent. Check your connection and try again.';
  var TIMEOUT_MS = 15000;
  var SETTLE_MS = 4000;

  /* the last email and variant that went through: a second tap on the same pair sends nothing */
  var sentKey = '';

  /* true only after the status route said {ok:true,on:true} (or a kept on answer under 10 minutes old) */
  var saveOn = false;

  /* true once the shopper has scrolled, touched, used the wheel or pressed a key (D42 f). It starts true when the page
     is already scrolled as the script runs, since a scroll made before this deferred script ran fires no event here (D48 a). */
  var touched = false;
  try {
    var y0 = window.pageYOffset || (document.scrollingElement && document.scrollingElement.scrollTop) || 0;
    if (y0 > 0) touched = true;
  } catch (e) { /* ignore */ }
  /* false when a late status answer found the shopper reading: the box stays hidden for this load */
  var showAllowed = true;
  (function () {
    function mark() { touched = true; }
    var evs = ['scroll', 'touchstart', 'wheel', 'keydown'];
    for (var i = 0; i < evs.length; i++) {
      try { window.addEventListener(evs[i], mark, { passive: true, capture: true }); } catch (e) { /* ignore */ }
    }
  })();

  function validEmail(email) {
    if (!email || email.length > 254) return false;
    if (email.indexOf('..') !== -1) return false;
    var m = /^([^\s@]+)@([^\s@]+)$/.exec(email);
    if (!m) return false;
    var local = m[1], domain = m[2];
    if (local.charAt(0) === '.' || local.charAt(local.length - 1) === '.') return false;
    if (domain.charAt(0) === '.' || domain.charAt(domain.length - 1) === '.') return false;
    var labels = domain.split('.');
    if (labels.length < 2) return false;
    for (var i = 0; i < labels.length; i++) {
      var l = labels[i];
      if (!l || l.charAt(0) === '-' || l.charAt(l.length - 1) === '-') return false;
    }
    return labels[labels.length - 1].length >= 2;
  }

  /* the variant on screen: the product form's own id first, then the URL, then the picker's state, then the page's first load */
  function selectedVariantId(box) {
    /* the product form's own input first: another cart form on the page (the pinned bar's) is updated a moment later */
    var inp = document.querySelector('product-form-component input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (inp && inp.value) return String(inp.value);
    try {
      var fromUrl = new URL(window.location.href).searchParams.get('variant');
      if (fromUrl) return String(fromUrl);
    } catch (e) { /* no URL support: fall through */ }
    var pj = document.querySelector('variant-picker script[type="application/json"]');
    if (pj) {
      try { var id = (JSON.parse(pj.textContent) || {}).id; if (id) return String(id); } catch (e) { /* ignore */ }
    }
    return String(box.getAttribute('data-variant') || '');
  }

  /* a carat or metal tap marks the page as changing (set in beylora-c-pdp-buy); wait for it to land, at most SETTLE_MS */
  function whenVariantSettled() {
    return new Promise(function (resolve) {
      var started = Date.now();
      (function check() {
        var p = window.beyVariantPending;
        if (!p || Date.now() - p >= 3500 || Date.now() - started >= SETTLE_MS) return resolve();
        setTimeout(check, 50);
      })();
    });
  }

  function setState(box, state, message) {
    box.setAttribute('data-state', state);
    var slot = box.querySelector('[data-bey-save-ring-msg]');
    if (slot) slot.textContent = message || '';
    var input = box.querySelector('input[type="email"]');
    if (input) {
      if (state === 'error' && message === MSG_BAD) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    }
    var button = box.querySelector('button');
    if (button) {
      var busy = state === 'busy';
      button.disabled = busy;
      button.textContent = busy ? button.getAttribute('data-busy') : button.getAttribute('data-label');
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
  }

  function send(email, variantId) {
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT_MS);
    /* text/plain keeps this a simple request: no preflight */
    return fetch(ROUTE, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ email: email, variant_id: variantId, website: '' }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) { clearTimeout(timer); return r.status; }, function (e) { clearTimeout(timer); throw e; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    var box = form.closest('[data-bey-save-ring]');
    if (!box) return;
    e.preventDefault();
    if (!saveOn) return; /* the route is off, down or not asked yet: nothing is sent */
    if (box.getAttribute('data-state') === 'busy') return;

    var input = box.querySelector('input[type="email"]');
    var button = box.querySelector('button');
    var email = (input && input.value ? input.value : '').trim().toLowerCase();
    if (!validEmail(email)) {
      setState(box, 'error', MSG_BAD);
      if (input) input.focus();
      return;
    }

    setState(box, 'busy', '');
    whenVariantSettled().then(function () {
      var variantId = selectedVariantId(box);
      if (!/^\d{1,20}$/.test(variantId)) { setState(box, 'error', MSG_FAIL); if (button) button.focus(); return null; }
      var key = email + '|' + variantId;
      if (key === sentKey) {
        /* already sent for this email and this variant: nothing goes out until one of them changes */
        setState(box, 'sent', MSG_SENT);
        if (button) button.focus();
        return null;
      }
      return send(email, variantId).then(function (status) {
        if (status >= 200 && status < 300) {
          sentKey = key;
          setState(box, 'sent', MSG_SENT);
        } else if (status === 400) {
          setState(box, 'error', MSG_BAD);
          if (input) input.focus();
          return;
        } else {
          /* 429: the daily or site cap is used up, so the kept on is dropped and the next load asks status again (D42 e) */
          if (status === 429) dropKeptOn();
          setState(box, 'error', MSG_FAIL);
        }
        if (button) button.focus();
      }, function () {
        setState(box, 'error', MSG_FAIL);
        if (button) button.focus();
      });
    });
  }, true);

  /* typing after an error or a send clears the message, so the next tap is a fresh one */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.type !== 'email') return;
    var box = t.closest('[data-bey-save-ring]');
    var state = box && box.getAttribute('data-state');
    if (state === 'error' || state === 'sent') setState(box, 'idle', '');
  });

  /* the kept on answer: sessionStorage, 10 minutes. Off is never kept. Every storage call is wrapped. */
  function readKeptOn() {
    try {
      var t = Number(window.sessionStorage.getItem(ON_KEY));
      var age = Date.now() - t;
      return t > 0 && age >= 0 && age < ON_KEEP_MS;
    } catch (e) { return false; }
  }
  function keepOn() {
    try { window.sessionStorage.setItem(ON_KEY, String(Date.now())); } catch (e) { /* storage blocked: ask again next load */ }
  }
  function dropKeptOn() {
    try { window.sessionStorage.removeItem(ON_KEY); } catch (e) { /* ignore */ }
  }

  /* ask GET <route>/status once, with a 4 s limit. Resolves true only for a parsed {ok:true,on:true}; never rejects. */
  function askStatus() {
    return new Promise(function (resolve) {
      var done = false;
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      function finish(v) { if (done) return; done = true; clearTimeout(timer); resolve(v); }
      var timer = setTimeout(function () { if (ctrl) { try { ctrl.abort(); } catch (e) { /* ignore */ } } finish(false); }, STATUS_TIMEOUT_MS);
      try {
        fetch(STATUS_ROUTE, { method: 'GET', credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { if (!r || !r.ok) return null; return r.json(); })
          .then(function (j) { finish(!!j && typeof j === 'object' && j.ok === true && j.on === true); })
          .catch(function () { finish(false); });
      } catch (e) { finish(false); }
    });
  }

  /* show the box. The product section is re-rendered on a carat or metal change and brings the hidden attribute back,
     so once the route has said on, the box is shown again whenever it is hidden. Before that, nothing is shown. */
  function reveal() {
    if (!saveOn || !showAllowed) return;
    var boxes = document.querySelectorAll('[data-bey-save-ring][hidden]');
    for (var i = 0; i < boxes.length; i++) boxes[i].removeAttribute('hidden');
  }

  /* D42 f: after the shopper has scrolled or touched, unhide only a box that sits at or below the bottom of the screen.
     The box now sits under Add to cart (D69), so it is also held back once the shopper has reached the buy controls: the top of
     the variant picker (metal and carat buttons) must still be below the bottom of the screen. A shopper reading the carat buttons
     or Add to cart gets the box on the next load (the kept on) and sees nothing appear while choosing.
     The box is unhidden, measured and put back in one go with no paint between, so nothing flashes or moves. */
  function belowScreen() {
    var boxes = document.querySelectorAll('[data-bey-save-ring][hidden]');
    if (!boxes.length) return false;
    var buy = document.querySelector('variant-picker');
    if (buy && !(buy.getBoundingClientRect().top >= window.innerHeight)) return false;
    var ok = true, opened = [];
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].removeAttribute('hidden');
      opened.push(boxes[i]);
      if (!(boxes[i].getBoundingClientRect().top >= window.innerHeight)) { ok = false; break; }
    }
    if (!ok) for (var j = 0; j < opened.length; j++) opened[j].setAttribute('hidden', '');
    return ok;
  }

  function switchOn(lateAnswer) {
    saveOn = true;
    if (lateAnswer && touched) showAllowed = belowScreen();
    if (!showAllowed) return; /* hidden for this load; the kept on shows it next load */
    reveal();
    if ('MutationObserver' in window) {
      new MutationObserver(reveal).observe(document.documentElement, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']
      });
    }
  }

  if (readKeptOn()) {
    switchOn(true); /* same position check as a late status answer (D48 a) */
  } else {
    askStatus().then(function (on) {
      if (on) { keepOn(); switchOn(true); } else { dropKeptOn(); }
    });
  }
})();
